import usePage from '../hooks/usePage';
import useStickyStack from '../hooks/useStickyStack';
import { transformProductsData } from '../utils/dataTransformer';
import ProductSection from '../components/ProductSection/ProductSection';
import './HomePage.css';

const HOME_SLUG = 'home';

const HomePage = () => {
    const { page, loading, error } = usePage(HOME_SLUG);

    const sections = page?.acf?.product_groups
        ? transformProductsData(page.acf.product_groups)
        : [];

    const { registerSection } = useStickyStack(sections.length);

    if (loading) {
        return (
            <div className="app-loading">
                <div className="app-loading__spinner" />
            </div>
        );
    }

    if (error || sections.length === 0) {
        return (
            <div className="error-state">
                <div className="error-state__icon">
                    <svg viewBox="0 0 48 48" fill="none" width="48" height="48">
                        <circle cx="24" cy="24" r="22" stroke="var(--green-dark)" strokeWidth="2" opacity="0.4" />
                        <path d="M24 14v12" stroke="var(--green)" strokeWidth="2.5" strokeLinecap="round" />
                        <circle cx="24" cy="32" r="1.5" fill="var(--green)" />
                    </svg>
                </div>
                <h2 className="error-state__title">Something went wrong</h2>
                <p className="error-state__message">
                    {error || 'No products available at the moment.'}
                </p>
                <button
                    className="btn btn-primary"
                    onClick={() => window.location.reload()}
                >
                    Retry
                </button>
            </div>
        );
    }

    return (
        <>
            <div className="sections-wrap">
                {sections.map((section, i) => (
                    <ProductSection
                        key={section.key}
                        section={section}
                        sectionIndex={i}
                        innerRef={registerSection(i)}
                    />
                ))}
            </div>
        </>
    );
};

export default HomePage;
